import { GroupUserControl, GroupSummary } from '../components';

export default function Groups() {
    return (
        <>
            <GroupUserControl />
            <GroupSummary />
        </>
    );
}